import Script from 'next/script';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  dezhinoData: ValidatedScripts['dezhino'];
}
export const DezhinoScript = ({
  dezhinoData
}: Props) => {
  if (!dezhinoData?.enabled) return null;
  return <Script defer strategy='lazyOnload' type='text/javascript' src='https://gate.dezhino.com/v2/8190580839.js' data-sentry-element="Script" data-sentry-component="DezhinoScript" data-sentry-source-file="dezhino.tsx" />;
};